import React from 'react';

interface Iprops {
    setIsFinal?: (isFinal: boolean) => void
}

function Final(props: Iprops) {

  return (
    <div className=' select-none'>
      <div className=' flex justify-center items-center h-[200px]'>
        <img alt='empty' src={require('../../../img/search_@3_empty.png')} className='w-[200px] h-[200px]' />
      </div>
      <div className='text-lg font-Poppins font-semibold text-black mt-[12px] text-center'>Your request was submitted successfully.</div>
      <div className='text-2xs font-Poppins font-normal text-grey mt-[8px] text-center'>Our staff will contact you as soon as possible</div>
    </div>
  );
}

export default Final;
